import React from 'react';
import { useState } from "react";
import axios from 'axios'
import { useNavigate } from "react-router-dom";
import './Home.css'; 
import iconISAE from '../images/LogoISAE.png';
import iconHADES from '../images/LogoHADES.jpg';
import { modeExecution, SITE_WEB } from './Global.js';
import { Link } from 'react-router-dom';




const Home = () => {

  const [username, setUsername] = useState()
  const [password, setPassword] = useState()
  const [errorMsg, setErrorMsg] = useState('');
  const navigate = useNavigate()

    
  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMsg('');

    // selon la config
    let url = '';
    url = SITE_WEB + '/home'

    console.log("[Home] url = ", url)
    // alert("toto")


    axios.post(url, { username, password })
      .then((result) => {
        // Quand le serveur renvoie 200, c'est OK
        if (result.status === 200) {
          console.log("Identification Ok");
          sessionStorage.setItem('token', result.data.token);
          sessionStorage.setItem('username', username);
          navigate('/dashboard');
        }
        // Si on arrive à un autre code 2xx => potentiellement un souci
        else {
          console.log("Identification error");
          setErrorMsg('Username or password incorrect.'); 
        }
      })
      .catch((err) => {
        // Ici, on peut avoir un status 401, 500, etc.
        if (err.response?.status === 401) {
          setErrorMsg('Username or password incorrect.');
        } else {
          console.log("1 = ", 1)
          console.log("err = ", err)
          console.log("err.response?.status = ", err.response?.status)
          setErrorMsg('Server connectionn error.');
        }
        console.log(err);
      });
  };



return (
    <div className="home-container">

      <div class="title-container">
        <h1 class="title-main">ACCADIL</h1>
        <h2 class="title-sub">Ancient Coin Classification Algorithm for DIe Links</h2>
      </div>
      
      <div class="background-image"></div>
      <div class="background-image-right"></div>
      <div className="form-container">

        {/* Affichage conditionnel du message d'erreur */}
        {errorMsg && (
          <div 
            className="alert alert-danger" 
            role="alert" 
            style={{ marginBottom: '20px' }}
          >
            {errorMsg}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="username">
              <strong>Username</strong>
            </label>
            <input
              type="text"
              placeholder="Enter username"
              autoComplete="off"
              className="form-control rounded-0"
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="password">
              <strong>Password</strong>
            </label>
            <input
              type="password"
              placeholder="Enter Password"
              className="form-control rounded-0"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button type="submit" className="btn btn-success w-100 rounded-0">
            Login
          </button>
        </form>
        <p>No account yet ? <Link to="/signup">Send a request here</Link></p>
        {/* <p>Want to reach the Accadil team, create an account, or delete your data? Just email us at accadil.project@gmail.com with your request, and if you’re signing up, add a short description of your project</p> */}
      </div>

      <div class="icons-container">
        <img src={iconISAE} alt="Icon ISAE" className="icon"/>
        <img src={iconHADES} alt="Icon HADES" className="icon"/>
      </div>
      
    </div>
  );
};

export default Home;

